/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shadows_EnableInputs */

const en_shadows_enable = /** @type {(inputs: Shadows_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable shadows`)
};

const fr_shadows_enable = /** @type {(inputs: Shadows_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer les ombres`)
};

const ms_sg2_shadows_enable = /** @type {(inputs: Shadows_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan bayang`)
};

/**
* | output |
* | --- |
* | "Enable shadows" |
*
* @param {Shadows_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const shadows_enable = /** @type {((inputs?: Shadows_EnableInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shadows_EnableInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shadows_enable(inputs)
	if (locale === "fr") return fr_shadows_enable(inputs)
	return ms_sg2_shadows_enable(inputs)
});